import { render, staticRenderFns } from "./InfluencerProfileChannelsTab.vue?vue&type=template&id=136799cb"
import script from "./InfluencerProfileChannelsTab.vue?vue&type=script&lang=js"
export * from "./InfluencerProfileChannelsTab.vue?vue&type=script&lang=js"
import style0 from "./InfluencerProfileChannelsTab.vue?vue&type=style&index=0&id=136799cb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports